var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "添加成交客户",
        visible: _vm.show,
        width: "690px",
        "close-on-click-modal": false,
        "before-close": _vm.closeDialog,
      },
      on: {
        "update:visible": function ($event) {
          _vm.show = $event
        },
      },
    },
    [
      _c("div", { staticClass: "tips" }, [
        _c("p", [
          _c("i", { staticClass: "el-icon-warning" }),
          _c(
            "i",
            {
              staticStyle: {
                color: "#333333",
                "margin-right": "0",
                "font-size": "13px",
              },
            },
            [_vm._v("温馨提示：")]
          ),
          _vm._v("请添加成交企业全称才可为您精准推荐数据"),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "searchBlock" },
        [
          _c(
            "el-autocomplete",
            {
              attrs: {
                "popper-class": "recommend-head-autocomplete",
                clearable: "",
                placeholder: _vm.placeholder,
                maxlength: 50,
                size: "small",
                "fetch-suggestions": _vm.querySearch,
              },
              on: { input: _vm.changeInput },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", {
                        staticClass: "name",
                        domProps: { innerHTML: _vm._s(item.name) },
                      }),
                    ]
                  },
                },
              ]),
              model: {
                value: _vm.inputValue,
                callback: function ($$v) {
                  _vm.inputValue = typeof $$v === "string" ? $$v.trim() : $$v
                },
                expression: "inputValue",
              },
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "fr",
                  attrs: {
                    slot: "suffix",
                    loading: _vm.loading,
                    type: "dialog-confirm",
                    size: "small",
                    disabled: _vm.addDisabled,
                  },
                  on: { click: _vm.addTable },
                  slot: "suffix",
                },
                [_vm._v("添加")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "tableMain" },
        [
          _c("div", { staticClass: "title" }, [_vm._v("已添加")]),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.waiting,
                  expression: "waiting",
                },
              ],
              staticClass: "companyList",
              staticStyle: { width: "100%" },
              attrs: { data: _vm.companyList, "max-height": "320" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "公司",
                  width: "557",
                  prop: "name",
                  resizable: false,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  width: "93",
                  "header-align": "center",
                  resizable: false,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "delete pointer tac",
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete(scope.$index, scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("div", [
            _c("div", { staticClass: "title" }, [_vm._v("关系选择")]),
            _c(
              "div",
              { staticClass: "selectBox fx-s-base" },
              [
                _c("div", { staticClass: "mr-16" }, [_vm._v("供应链关系")]),
                _c(
                  "el-checkbox-group",
                  {
                    model: {
                      value: _vm.supplySelected,
                      callback: function ($$v) {
                        _vm.supplySelected = $$v
                      },
                      expression: "supplySelected",
                    },
                  },
                  _vm._l(_vm.supplyList, function (item, index) {
                    return _c(
                      "el-checkbox",
                      {
                        key: index,
                        staticStyle: { width: "80px" },
                        attrs: { label: item.value },
                      },
                      [_vm._v(_vm._s(item.label))]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "selectBox fx-s-base" },
              [
                _c("div", { staticClass: "mr-16" }, [_vm._v("股权链关系")]),
                _c(
                  "el-checkbox-group",
                  {
                    model: {
                      value: _vm.stockRightSelected,
                      callback: function ($$v) {
                        _vm.stockRightSelected = $$v
                      },
                      expression: "stockRightSelected",
                    },
                  },
                  _vm._l(_vm.stockRightList, function (item, index) {
                    return _c(
                      "el-checkbox",
                      {
                        key: index,
                        staticStyle: { width: "80px" },
                        attrs: { label: item.value },
                      },
                      [_vm._v(_vm._s(item.label))]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "dialog-confirm", w88: "" },
              on: { click: _vm.submit },
            },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }